import sdk from "@repo/api-sdk";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";

export function categoryProductCountsQuery() {
  return queryOptions({
    queryKey: queryKeys.productCounts(),
    queryFn: () => sdk.store.category.getProductCounts()
  });
}

export function useCategoryProductCounts(options?: { enabled?: boolean }) {
  return useQuery({
    ...categoryProductCountsQuery(),
    ...options
  });
}
